import { Component } from '@theme/component';

class BarryWorkPreview extends Component {
  controller;
  observer;
  active = false;
  reduced = matchMedia('(prefers-reduced-motion: reduce)');
  fine = matchMedia('(hover: hover) and (pointer: fine)');
  connectedCallback() {
    super.connectedCallback();
    this.setup();
  }
  updatedCallback() {
    super.updatedCallback();
    this.cleanup();
    this.setup();
  }
  setup() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    const card = this.closest('.bc-work-card');
    if (!card || !this.refs.preview) return;
    card.addEventListener('pointerenter', () => this.start(), options);
    card.addEventListener('pointerleave', () => this.stop(), options);
    card.addEventListener('focusin', () => this.start(), options);
    card.addEventListener('focusout', (event) => {
      if (!card.contains(event.relatedTarget)) this.stop();
    }, options);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.stop();
    }, options);
    this.reduced.addEventListener('change', () => this.stop(), options);
    this.fine.addEventListener('change', () => this.stop(), options);
    this.observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) this.stop();
    });
    this.observer.observe(card);
  }
  async start() {
    if (this.active || !this.fine.matches || this.reduced.matches || navigator.connection?.saveData) return;
    const video = this.refs.preview;
    const source = video?.querySelector('source');
    if (!video || !source) return;
    this.active = true;
    if (!source.getAttribute('src')) {
      source.src = source.dataset.src;
      video.load();
    }
    try {
      await video.play();
      if (this.active) this.classList.add('bc-preview-playing');
      else video.pause();
    } catch {
      this.stop();
    }
  }
  stop() {
    this.active = false;
    this.refs.preview?.pause();
    this.classList.remove('bc-preview-playing');
  }
  cleanup() {
    this.stop();
    this.controller?.abort();
    this.observer?.disconnect();
  }
  disconnectedCallback() {
    this.cleanup();
    super.disconnectedCallback();
  }
}
if (!customElements.get('bc-work-preview')) customElements.define('bc-work-preview', BarryWorkPreview);

